import React from "react";
import { DebitListForBilling } from "@icoach/batchPayment/component";
import { useBatchPaymentContext } from "@icoach/batchPayment/component/BatchPaymentContext";

/** =========================================================
 * 📌 會籍月費扣款結果列表
 *  =========================================================
 */
const MembershipBatchPaymentBatchDebitHistory = () => {
	const { batchPaymentLists } = useBatchPaymentContext();

	return <DebitListForBilling list={batchPaymentLists?.billings || []} />;
};

export default MembershipBatchPaymentBatchDebitHistory;
